import type { Theme, Components, ComponentsVariants } from '@mui/material/styles';

// ----------------------------------------------------------------------

/**
 * TypeScript extension for MUI theme augmentation.
 * @to {@link file://./../../extend-theme-types.d.ts}
 */

export type IconButtonExtendVariant = {
  grey: true;
};

const greyVariants = [
  {
    props: (props) => props.variant === 'grey',
    style: ({ theme }) => ({
      backgroundColor: theme.vars.palette.grey['200'],
      '&:hover': {
        backgroundColor: theme.vars.palette.grey['300'],
      },
      '& .MuiTouchRipple-root': {
        borderRadius: 'inherit !important',
      },
      '& .MuiTouchRipple-child': {
        backgroundColor: theme.vars.palette.grey['400'],
        borderRadius: 'inherit !important',
      },
      '& .MuiTouchRipple-rippleVisible': {
        borderRadius: 'inherit !important',
      },
    }),
  },
] satisfies ComponentsVariants<Theme>['MuiIconButton'];

const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
      '&:hover': {
        backgroundColor: theme.vars.palette.action.hover,
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.action.disabled,
      },
      // Ripple effect with 8px border radius
      '& .MuiTouchRipple-root': {
        borderRadius: 'inherit !important',
      },
      '& .MuiTouchRipple-child': {
        borderRadius: 'inherit !important',
      },
      '& .MuiTouchRipple-rippleVisible': {
        borderRadius: 'inherit !important',
      },
      variants: [...greyVariants],
    }),
    sizeSmall: {
      padding: 4,
    },
    sizeMedium: {
      padding: 8,
    },
    sizeLarge: {
      padding: 12,
    },
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const iconButton: Components<Theme> = {
  MuiIconButton,
};
